quoteModule.factory("SingleProductInfo", function() {

    var SingleProductInfo = function(){
        this.productInternalId= null; //the main product internal id
        this.productTypeInternalId= null; //the main product type internal id
        this.productRateReady= false;
        //"selected" product attributes before rating (filled from ui choices)
        this.selectedCoverageVal= null;//primary coverage
        this.selectedDeductibleVal= null;//primary deductible
        this.selectedOptionValDisplay = [];
        this.selectedOptionVal= [];//primary options
        this.selectedNoUpgradeTermVal= null;//base lw term (no upgrade)
        this.selectedUpgradeProductVal= null;//upgrade product
        this.selectedUpgradeCoverageVal= null;//upgrade coverage
        this.selectedUpgradeDeductibleVal= null;//upgrade deductible
        this.selectedUpgradeOptionVal= [];//upgrade options
        //"forced" product attributes before populating options
        this.selectedCoverageForce= null;//primary coverage
        this.selectedDeductibleForce= null;//primary deductible
        this.selectedOptionForce= [];//primary options
        this.selectedNoUpgradeTermForce= null;//base lw term (no upgrade)
        this.selectedUpgradeProductForce= null;//upgrade product
        this.selectedUpgradeCoverageForce= null;//upgrade coverage
        this.selectedUpgradeDeductibleForce= null;//upgrade deductible
        this.selectedUpgradeOptionForce= [];//upgrade options
        //lists of product attributes to display
        this.availCoverages= null;//available coverages
        this.availDeductibles= null;//available deductibles
        this.availOptions= null;//available options (surcharges)
        this.baseNoUpgradeTerms= null;//available base lw terms
        this.upgradeProducts= null;//available upgrade products
        this.upgradeCoverages= null;//available upgrade coverages
        this.upgradeDeductibles= null;//available upgrade deductibles
        this.upgradeOptions= null;//available upgrade options
        this.productIncomplete = false;
        this.productIncompleteFields = [];
        this.surchargeDefaultsRetrieved = false;
        this.defaultDeductibleSelected = null;
    }
    return SingleProductInfo;
});

